var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-pager',{attrs:{"current-page":_vm.pagination.current_page,"last-page":_vm.pagination.last_page},on:{"navigate":function($event){return _vm.$emit('navigate', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }